import { unwrapResult } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import { attachCodeToSpan, detachCodeFromSpan, deleteSpan, addEmptySpan } from '../actions/grade-bench-panel-actions';
import { ThunkDispatch } from 'redux-thunk';

export const enrichingAnnotationHooks = {
  attachCode: async (dispatch: Dispatch<any>, params: CQA.AttachCodeToSpanParams) => {
    return dispatch(attachCodeToSpan(params));
  },

  detachCode: async (dispatch: Dispatch<any>, params: CQA.DetachCodeFromSpanParams) => {
    return dispatch(detachCodeFromSpan(params));
  },

  deleteSpan: async (dispatch: Dispatch<any>, params: CQA.DeleteSpanParams) => {
    return dispatch(deleteSpan(params));
  },

  addEmptySpan: async (dispatch: ThunkDispatch<any, any, any>, spanData: CQA.SpanAnnotationDocument): Promise<Accelerate.SpanAnnotation | null> => {
    // RTK async thunks resolve to the action object; unwrapResult extracts the fulfilled payload (works with ThunkDispatch typing).
    const spanDocument = unwrapResult(await dispatch(addEmptySpan(spanData)));
    if (!spanDocument || !spanDocument.spans || spanDocument.spans.length === 0) {
      return null;
    }
    return spanDocument.spans[0];
  }
};
